/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import {useMemo} from 'react'

interface MappedSelectOption {
    label: string
    description?: string
    value: string,
	position?: number
	category?: string
}

const useMappedSelectOptions = (items: any[]): MappedSelectOption[] => {
    return useMemo(() => {
        return (items || []).map(
            (item: {
                label?: string
                name?: string
                value?: string
                position?: number
				category?: string
                id?: string
                description?: string
            }) => {
                const label = item.label ?? item.name ?? String(item.value ?? item.id ?? '')
                const value = item.value ?? item.id ?? item.name ?? item.label ?? ''
                return {
                    label,
                    description: item.description ?? '',
                    value,
                    position: item.position ?? null,
                    category: item.category ?? null,
                }
            }
        )
    }, [items])
}

export default useMappedSelectOptions
